export default __webpack_public_path__ + "static/media/microserviices.f91ca645.jpeg";